import React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiButton from "@mui/material/Button";
import MuiTextField from "@mui/material/TextField";
import MuiCheckbox from "@mui/material/Checkbox";
import MuiFormHelperText from "@mui/material/FormHelperText";

// Source
import * as HelperSrc from "../../HelperSrc";
import * as ModelHelperSrc from "../../model/HelperSrc";
import ControllerLocalization from "../../controller/Localization";
import ControllerClientProfile from "../../controller/custom/ClientProfile";
import ViewLoader from "../Loader";

let isRendered = false;

const viewPageClientProfile: React.FC = () => {
    // Variable
    const controllerClientProfile = new ControllerClientProfile(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerClientProfile.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain && controllerClientProfile.getSelectOption && controllerClientProfile.getValidationForm) {
        return (
            <div className="view_client_profile form" data-at_id="view_client_profile">
                {(() => {
                    const html: JSX.Element[] = [];

                    if (controllerClientProfile.getDataMain) {
                        html.push(
                            <div>
                                <div>
                                    {(() => {
                                        const html: JSX.Element[] = [];

                                        html.push(
                                            <div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value disabled"
                                                        name="id"
                                                        label={controllerLocalization.getStorageMain.id}
                                                        defaultValue={controllerClientProfile.getDataMain.id || ""}
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value date"
                                                        data-at_id="input_latest_update"
                                                        name="latest_update"
                                                        label={controllerLocalization.getStorageMain.latest_update}
                                                        value={
                                                            controllerClientProfile.getDataMain.latest_update
                                                                ? HelperSrc.localeFormat(new Date(controllerClientProfile.getDataMain.latest_update))
                                                                : ""
                                                        }
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value"
                                                        data-at_id="input_latest_update_by_id"
                                                        name="latest_update_by_id"
                                                        label={controllerLocalization.getStorageMain.latest_update_by}
                                                        defaultValue={(() => {
                                                            for (const optionData of Object.values(
                                                                controllerClientProfile.getSelectOption.latest_update_by_id
                                                            )) {
                                                                const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                                if (
                                                                    controllerClientProfile.getDataMain.latest_update_by_id === optionDataTyped.value
                                                                ) {
                                                                    return optionDataTyped.display_name;
                                                                }
                                                            }
                                                        })()}
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                            </div>
                                        );

                                        return html;
                                    })()}
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_username"
                                            name="username"
                                            label={controllerLocalization.getStorageMain.username}
                                            defaultValue={controllerClientProfile.getDataMain.username || ""}
                                            required={controllerClientProfile.getValidationForm.username.required}
                                            onChange={(event) => {
                                                if (controllerClientProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientProfile.getValidationForm.username.regex_pattern,
                                                        controllerClientProfile.getValidationForm.username.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_username_kana"
                                            name="username_kana"
                                            label={controllerLocalization.getStorageMain.username_kana}
                                            defaultValue={controllerClientProfile.getDataMain.username_kana || ""}
                                            required={controllerClientProfile.getValidationForm.username_kana.required}
                                            onChange={(event) => {
                                                if (controllerClientProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientProfile.getValidationForm.username_kana.regex_pattern,
                                                        controllerClientProfile.getValidationForm.username_kana.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_username_official"
                                            name="username_official"
                                            label={controllerLocalization.getStorageMain.username_official}
                                            defaultValue={controllerClientProfile.getDataMain.username_official || ""}
                                            required={controllerClientProfile.getValidationForm.username_official.required}
                                            onChange={(event) => {
                                                if (controllerClientProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientProfile.getValidationForm.username_official.regex_pattern,
                                                        controllerClientProfile.getValidationForm.username_official.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_username_abbreviation"
                                            name="username_abbreviation"
                                            label={controllerLocalization.getStorageMain.username_abbreviation}
                                            defaultValue={controllerClientProfile.getDataMain.username_abbreviation || ""}
                                            required={controllerClientProfile.getValidationForm.username_abbreviation.required}
                                            onChange={(event) => {
                                                if (controllerClientProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientProfile.getValidationForm.username_abbreviation.regex_pattern,
                                                        controllerClientProfile.getValidationForm.username_abbreviation.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_request_code"
                                            name="request_code"
                                            label={controllerLocalization.getStorageMain.request_code}
                                            defaultValue={controllerClientProfile.getDataMain.request_code || ""}
                                            required={controllerClientProfile.getValidationForm.request_code.required}
                                            onChange={(event) => {
                                                if (controllerClientProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientProfile.getValidationForm.request_code.regex_pattern,
                                                        controllerClientProfile.getValidationForm.request_code.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_spc_name"
                                            name="spc_name"
                                            label={controllerLocalization.getStorageMain.spc_name}
                                            defaultValue={controllerClientProfile.getDataMain.spc_name || ""}
                                            required={controllerClientProfile.getValidationForm.spc_name.required}
                                            onChange={(event) => {
                                                if (controllerClientProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientProfile.getValidationForm.spc_name.regex_pattern,
                                                        controllerClientProfile.getValidationForm.spc_name.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_gis"
                                            name="gis"
                                            label={controllerLocalization.getStorageMain.gis}
                                            defaultValue={controllerClientProfile.getDataMain.gis || ""}
                                            required={controllerClientProfile.getValidationForm.gis.required}
                                            onChange={(event) => {
                                                if (controllerClientProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientProfile.getValidationForm.gis.regex_pattern,
                                                        controllerClientProfile.getValidationForm.gis.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_engagement_code"
                                            name="engagement_code"
                                            label={controllerLocalization.getStorageMain.engagement_code}
                                            defaultValue={controllerClientProfile.getDataMain.engagement_code || ""}
                                            required={controllerClientProfile.getValidationForm.engagement_code.required}
                                            onChange={(event) => {
                                                if (controllerClientProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientProfile.getValidationForm.engagement_code.regex_pattern,
                                                        controllerClientProfile.getValidationForm.engagement_code.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_country"
                                            name="country"
                                            label={controllerLocalization.getStorageMain.country}
                                            defaultValue={controllerClientProfile.getDataMain.country || ""}
                                            required={controllerClientProfile.getValidationForm.country.required}
                                            onChange={(event) => {
                                                if (controllerClientProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientProfile.getValidationForm.country.regex_pattern,
                                                        controllerClientProfile.getValidationForm.country.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <span className="checkbox_label">{controllerLocalization.getStorageMain.is_fund_request}:</span>
                                        <MuiCheckbox
                                            className="field_value checkbox_style"
                                            data-at_id="input_is_fund_request"
                                            name="is_fund_request"
                                            defaultChecked={controllerClientProfile.getDataMain.is_fund_request || false}
                                            required={controllerClientProfile.getValidationForm.is_fund_request.required}
                                            onChange={(event) => {
                                                if (controllerClientProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientProfile.getValidationForm.is_fund_request.regex_pattern,
                                                        controllerClientProfile.getValidationForm.is_fund_request.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <span className="checkbox_label">{controllerLocalization.getStorageMain.is_active}:</span>
                                        <MuiCheckbox
                                            className="field_value checkbox_style"
                                            data-at_id="input_is_active"
                                            name="is_active"
                                            defaultChecked={controllerClientProfile.getDataMain.is_active || false}
                                            required={controllerClientProfile.getValidationForm.is_active.required}
                                            onChange={(event) => {
                                                if (controllerClientProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerClientProfile.getValidationForm.is_active.regex_pattern,
                                                        controllerClientProfile.getValidationForm.is_active.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                </div>
                                <div className="bottom">
                                    <div className="button_container">
                                        <MuiButton
                                            className="button_primary"
                                            data-at_id="button_update"
                                            disabled={controllerClientProfile.getApiLoadingList.profileChange}
                                            onClick={(event) => {
                                                controllerClientProfile.clickChange(event);
                                            }}
                                        >
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                if (controllerClientProfile.getApiLoadingList.profileChange) {
                                                    html.push(<MuiCircularProgress className="icon_progress" />);
                                                } else {
                                                    html.push(<>{controllerLocalization.getStorageMain.update}</>);
                                                }

                                                return html;
                                            })()}
                                        </MuiButton>
                                    </div>
                                </div>
                            </div>
                        );
                    }

                    return html;
                })()}
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPageClientProfile;
